import { render, staticRenderFns } from "./WaitAdminVerify.vue?vue&type=template&id=7d3b533e"
import script from "./WaitAdminVerify.vue?vue&type=script&lang=js"
export * from "./WaitAdminVerify.vue?vue&type=script&lang=js"
import style0 from "./WaitAdminVerify.vue?vue&type=style&index=0&id=7d3b533e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports